import { ChangeDetectionStrategy, Component } from '@angular/core'
import { OrderConfirmationTotalsComponent, OrderDetailsService } from '@spartacus/order/components'
import { OrderFacade } from '@spartacus/order/root'

@Component({
    selector: 'eb-order-confirmation-totals',
    templateUrl: './eb-order-confirmation-totals.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EbOrderConfirmationTotalsComponent extends OrderConfirmationTotalsComponent {
  order$ = this.orderDetailsService.getOrderDetails()

  constructor(
    orderFacade: OrderFacade,
    protected orderDetailsService: OrderDetailsService
  ) {
    super(orderFacade)
  }
  ngOnDestroy() {
    super.ngOnDestroy()
  }
}
